import * as React from "react";
import FileItem from "./FileItem";

var FileGroup = function FileGroup(props) {
  var fileType = props.fileType,
      files = props.files,
      admin = props.admin,
      _onEdit = props.onEdit,
      _onDelete = props.onDelete;
  if (files.length === 0) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "file-group",
    style: {
      marginBottom: "12px"
    }
  }, /*#__PURE__*/React.createElement("h6", {
    style: {
      marginBottom: "6px",
      fontWeight: "bold",
      fontSize: "14px",
      color: "#333"
    }
  }, fileType.label), /*#__PURE__*/React.createElement("div", null, files.map(function (file) {
    return /*#__PURE__*/React.createElement(FileItem, {
      key: file.id,
      file: file,
      admin: admin,
      onEdit: function onEdit() {
        return _onEdit(file);
      },
      onDelete: function onDelete() {
        return _onDelete(file.id);
      }
    });
  })));
};

export default FileGroup;